export default __webpack_public_path__ + "static/media/background.3753afee.jpg";